import {
  GET_TRANSFER_LINE_ORDER_APPROVAL_REQUEST,
  GET_TRANSFER_LINE_ORDER_APPROVAL_SUCCESS,
  GET_TRANSFER_LINE_ORDER_APPROVAL_FAILURE,
  GET_TRANSFER_LINE_DOC_BY_ID_REQUEST,
  GET_TRANSFER_LINE_DOC_BY_ID_SUCCESS,
  GET_TRANSFER_LINE_DOC_BY_ID_FAILURE,
  GET_UNMASKING_APPROVAL_REQUEST,
  GET_UNMASKING_APPROVAL_SUCCESS,
  GET_UNMASKING_APPROVAL_FAILURE,
  UPDATE_UNMASKING_APPROVAL_STATUS_REQUEST,
  UPDATE_UNMASKING_APPROVAL_STATUS_SUCCESS,
  UPDATE_UNMASKING_APPROVAL_STATUS_FAILURE
} from '@/actions/approval/actionTypes';

export const initialState = {
  approvalType: '',
  isLoading: false,
  orderDetails: {},
  transferLineDoc: [],
  isApprovalLoading: false,
  approvalOrderStatus: '',
  isError: ''
};

const approvalReducers = (state = initialState, action) => {
  switch (action.type) {
    case GET_TRANSFER_LINE_ORDER_APPROVAL_REQUEST:
      return {
        ...state,
        approvalType: 'TRANSFER_LINE',
        orderDetails: {},
        isLoading: true,
        isError: '',
      };
    case GET_UNMASKING_APPROVAL_SUCCESS:
    case GET_TRANSFER_LINE_ORDER_APPROVAL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        orderDetails: action.data
      };
    case GET_UNMASKING_APPROVAL_FAILURE:
    case GET_TRANSFER_LINE_DOC_BY_ID_FAILURE:
    case GET_TRANSFER_LINE_ORDER_APPROVAL_FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: action.error.response?.data?.message
      };

    case GET_TRANSFER_LINE_DOC_BY_ID_REQUEST:
      return {
        ...state,
        isLoading: true,
        transferLineDoc: [],
        isError: ''
      };
    case GET_TRANSFER_LINE_DOC_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        transferLineDoc: action.data
      };

    case GET_UNMASKING_APPROVAL_REQUEST:
      return {
        ...state,
        approvalType: 'UNMASKING',
        orderDetails: {},
        approvalOrderStatus: '',
        isLoading: true,
        isError: '',
      };

    case UPDATE_UNMASKING_APPROVAL_STATUS_REQUEST:
      return {
        ...state,
        isApprovalLoading: true,
        isError: '',
      };
    case UPDATE_UNMASKING_APPROVAL_STATUS_SUCCESS:
      return {
        ...state,
        isApprovalLoading: false,
        orderDetails: action.data
      };
    case UPDATE_UNMASKING_APPROVAL_STATUS_FAILURE:
      return {
        ...state,
        isApprovalLoading: false,
        isError: action.error.response?.data?.message
      };
    default:
      return state;
  }
};

export default approvalReducers;
